angular
	.module('logbook')
	.directive('schedulerCell',['$http', '$interval', '$location', '$rootScope', '$q', '$timeout',
function($http, $interval, $location, $rootScope, $q, $timeout) {
	return {
		restrict: 'E',
		template: require('./scheduler-cell.html'),
		
		scope: {
			onBind: '=',
			cellObj: '='
		},
		
		link: function(scope, elem, attrs)
		{
			if (scope.cellObj == undefined)
			{
				scope.cellObj = { options: {} };
				console.error('No cellObj passed for scheduler-cell')
			}
			else if (!scope.cellObj.options)
				scope.cellObj.options = {};

			scope.model = {
				minutes: {
					exact: {
						value: 0
					},
					range: {
						interval: 1,
						start: 0,
						end: 1,
						
						startEnabled: true,
						endEnabled: true
					}
				},
				hours: {
					exact: {
						value: 0
					},
					range: {
						interval: 1,
						start: 0,
						end: 1,
						
						startEnabled: true,
						endEnabled: true
					}
				},
				weekdays: {
					exact: {
						Sun: false,
						Mon: false,
						Tues: false,
						Wed: false,
						Thurs: false,
						Fri: false,
						Sat: false
					}
				},
				monthdays: {
					exact: {
						value: 1
					},
					range: {
						interval: 1,
						start: 1,
						end: 1,
						
						startEnabled: true,
						endEnabled: true
					}
				}
			};

			scope.elem = elem;
			scope.$timeout = $timeout;
			setupSchedulerCell(scope);

			// On Day button click event
			scope.dayBtnClick = function(e)
			{
				var day = $(e.currentTarget).attr('weekday');

				if (day != undefined)
					scope.model.weekdays.exact[day] = !scope.model.weekdays.exact[day];

				scope.onChange(e);
			};

			if (typeof scope.onBind === 'function')
				scope.onBind(scope.cellObj);

			scope.setCellType(scope.type, scope.subType, null, !scope.cellObj.options.suppressOnChange);
			scope.$emit('cellCreated', scope);
		}
	}
}]);

export function setupSchedulerCell(scope)
{
	var elem = scope.elem;
	var $timeout = scope.$timeout;

	if (scope.cellObj.model)
	{
		Object.assign(scope.model[scope.cellObj.type][scope.cellObj.subType],
			scope.cellObj.model[scope.cellObj.type][scope.cellObj.subType])
	}
	scope.cellObj.model = scope.model;

	scope.type = scope.cellObj.type;
	scope.subType = scope.cellObj.subType;

	scope.onChangeEvents = [];
	scope.onDeleteEvents = [];

	/**
	 * Gets the type key list from the model
	 * @returns {string[]}
	 */
	scope.getModelTypes = function()
	{
		return Object.keys(scope.model);
	};

	/**
	 * Gets the subType key list for a specified type
	 * @param {string} type
	 * @returns {string[]}
	 */
	scope.getTypeSubTypes = function(type)
	{
		return (scope.model[type] == undefined) ? [] : Object.keys(scope.model[type]);
	};

	/**
	 * Switches the cell to a confirmation for deleting the cell
	 * @param e - Event triggering the delete
	 */
	scope.askForDelete = function(e)
	{
		$(elem).find('#cell-body').toggleClass('values-disabled', true);
		$(elem).find('#default-edit-panel').toggleClass('hidden', true);
		$(elem).find('#ask-for-delete').toggleClass('hidden', false);
	};

	/**
	 * Calls all set onDelete event and then destroys the scope
	 * @param e - Event that triggers the deletion
	 */
	scope.onDelete = function(e)
	{
		scope.$emit('cellOnDelete', scope);
		scope.onDeleteEvents.forEach(function(func)
		{
			if (typeof func === 'function')
				func(scope, e)
		});
		scope.$destroy();
	};

	// Calls all set on change events
	scope.onChange = function(e)
	{
		if (e && e.target)
		{
			var $target = $(e.target);

			if ($target.attr('type') === 'number')
			{
				var value = $target.val();

				if (value === '')
				{
					var min;
					if (e.type !== 'change') return;
					else if (!isNaN(min = parseInt($target.attr('min'))))
					{
						$target.val(min);
						$target.change();
						return;
					}
				}
				if (value === '' && e.type !== 'change')
					return;
				if (parseInt($target.attr('min')) > value)
				{
					$target.val(parseInt($target.attr('min')));
					$target.change();
					return;
				}
				else if (parseInt($target.attr('max')) < value)
				{
					$target.val(parseInt($target.attr('max')));
					$target.change();
					return;
				}
			}

		}

		scope.$emit('cellOnChange', scope);
		scope.onChangeEvents.forEach(function(func)
		{
			if (typeof func === 'function')
				func(scope.model, { type: scope.type, subType: scope.subType },e)
		})
	};

	/**
	 * Sets the cell to a specified type and subType. If not subType is passed the first subType is selected.
	 * @param {string} type - Type from model to set cell to
	 * @param {string=} subType - Sub Type from model to set cell to
	 * @param {event=} event - The event that triggered the Cell Type Change
	 * @param {boolean=} fireOnChange - Whether to fireOnChangeEvent, default true
	 */
	scope.setCellType = function(type, subType, event, fireOnChange)
	{
		fireOnChange = (typeof fireOnChange === 'boolean') ? fireOnChange : true;
		type = type || scope.type;

		// Verifies the type is supported by the model
		if (!scope.getModelTypes().includes(type)) return;

		$(elem).find('#cell-body').toggleClass('values-disabled', false);
		$(elem).find('#default-edit-panel').toggleClass('hidden', false);
		$(elem).find('#ask-for-delete').toggleClass('hidden', true);

		var $btnGroup = $(elem).find('#btn-group-subtype').html('');
		var $button = $(elem).find('.sub-type-btn');

		var subTypes = scope.getTypeSubTypes(type);

		$(elem)
			.find('[main-type]').toggleClass('hidden', true)
			.find('[sub-type]').toggleClass('hidden', true);

		$(elem)
			.find('[main-type=' + type + ']')
			.toggleClass('hidden', false)
			.find('[sub-type]')
			.each(function(index)
			{
				var $element = $(this);
				var elemSubType = $element.attr('sub-type');
				var isVisible = (elemSubType === subType || (subType == undefined && index === 0));

				// Verifies the model supports the specified subType
				if (!subTypes.includes(elemSubType)) return;

				$element.toggleClass('hidden', !isVisible);
				$btnGroup.append('<button sub-type="' + elemSubType + '" class="btn btn-sm subtype-btn ' + ((isVisible) ? 'btn-primary' : 'btn-default') + '">' + elemSubType + '</button>');
				if (isVisible)
				{
					subType = elemSubType;
					$button.html($element.attr('sub-type') + ' <span class="glyphicon glyphicon-menu-down"></span>');
				}
			});

		scope.cellObj.type = scope.type = type;
		scope.cellObj.subType = scope.subType = subType;

		if (fireOnChange) scope.onChange(event);
	};

	scope.cellObj.getType = function() { return scope.type; };
	scope.cellObj.getSubType = function() { return scope.subType; };
	scope.cellObj.addOnChangeEvent = function(func) { scope.onChangeEvents.push(func) };
	scope.cellObj.addOnDeleteEvent = function(func) { scope.onDeleteEvents.push(func) };
	scope.cellObj.delete = function() { scope.onDelete() };
	scope.cellObj.setCellType = scope.setCellType;

	/**
	 * Applies options to the cell from the cell object
	 */
	scope.cellObj.applyOptions = scope.applyOptions = function()
	{
		if (scope.cellObj.options)
		{
			var options = scope.cellObj.options;

			$(elem).find('#btn-delete-cell')
				.toggleClass('hidden', (options.hasOwnProperty('deleteable')) ? !options.deleteable : false);

			var hideSubTypes = (scope.getTypeSubTypes(scope.type).length <= 1 || !!options.staticSubType);
			$(elem).find('#btn-group-subtype')
				.toggleClass('hidden', hideSubTypes);

			$(elem).toggleClass('values-disabled', (options.hasOwnProperty('editable') ? !options.editable : false));

			if ((options.hasOwnProperty('deleteable') ? !options.deleteable : false) && hideSubTypes)
				$(elem).find('.panel-heading').addClass('hidden');
		}
	};

	scope.applyOptions();

	$(elem)
		.change(function(e)
		{
			$timeout(function()
			{
				scope.onChange(e);
			});
		})
		.on('input', function(e)
		{
			$timeout(function()
			{
				scope.onChange(e);
			});
		});

	$(elem).on('click', '.sub-type-option', function(e)
	{
		scope.setCellType(scope.type, e.currentTarget.innerHTML, e);
	});

	$(elem).on('click', '.subtype-btn', function(e)
	{
		scope.setCellType(scope.type, $(e.target).attr('sub-type'), e);

	});
}